//手机号正则
export const phoneNumberReg =
  /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/;
export const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export const passwordRdeg =
  /^(?=.*[a-z])(?=.*\d)[\w!@#$%^&*()\-+={}[\]:";'<>,.?/|\\]{6,}$/;
